export default "/static/build/ai.png";